import React from 'react'

function ChevronLeftIcon() {
  return (
    <svg
      className="cursor-pointer"
      width="22"
      height="19"
      viewBox="0 0 22 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.457764 8.39648C-0.152588 9.00684 -0.152588 9.99805 0.457764 10.6084L8.27026 18.4209C8.88062 19.0313 9.87183 19.0313 10.4822 18.4209C11.0925 17.8105 11.0925 16.8193 10.4822 16.209L5.33081 11.0625H20.3113C21.1755 11.0625 21.8738 10.3643 21.8738 9.5C21.8738 8.63574 21.1755 7.9375 20.3113 7.9375H5.33569L10.4773 2.79102C11.0876 2.18066 11.0876 1.18945 10.4773 0.579102C9.86694 -0.03125 8.87573 -0.03125 8.26538 0.579102L0.452881 8.3916L0.457764 8.39648Z"
        fill="#5E06B9"
      />
    </svg>
  )
}

export default ChevronLeftIcon
